import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/sanitize.scss");
;
import(/* webpackMode: "eager" */ "/app/styles/global.scss");
